/* Memoria: behaviour for sections/mj-pdp-reviews.liquid.
   Loaded with defer, so the Judge.me section further down the page already exists. */
(function () {
  function init(root) {
    if (root.dataset.mjPrReady) return;
    root.dataset.mjPrReady = '1';
    var star = root.querySelector('.mj-pr__summary .mj-pr__star');
    var starSvg = star ? star.outerHTML.replace(/ ?mj-pr__star--(half|off)/g, '') : '';
    /* Taal: Engels op /en/ (US-teksten), anders Nederlands */
    var isEN = String(root.dataset.mjLang || document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

    /* Judge.me's own list stays hidden: the full list lives in the reviews side panel
       (snippets/mj-reviews-drawer.liquid). Judge.me's "Write a review" form is a modal on
       <body>, so it still opens while the list is hidden. */
    var jd = document.querySelector('.jdgm-review-widget');
    var jdSection = jd && jd.closest('.shopify-section');
    if (jdSection) jdSection.classList.add('mj-pr-jdgm', 'mj-pr-jdgm-collapsed');
    window.mjOpenReviewForm = function () {
      var write = jdSection && [].slice.call(jdSection.querySelectorAll('.jm-button, .jdgm-write-rev-link, button'))
        .filter(function (b) { return /schrijf|review schrijven|schreiben|write/i.test(b.textContent); })[0];
      if (write) write.click();
    };
    root.querySelectorAll('[data-mj-pr-write]').forEach(function (b) {
      b.addEventListener('click', function () { window.mjOpenReviewForm(); });
    });
    /* The stars under the product title: open the side panel instead of scrolling to the hidden list. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.jdgm-prev-badge')) return;
      var opener = document.querySelector('.mj-rd-row [data-mj-rd-open]') || root.querySelector('[data-mj-rd-open]');
      if (!opener) return;
      e.preventDefault();
      e.stopPropagation();
      opener.click();
    }, true);

    /* Sliders: photo strip and review cards share the same arrows/dots logic. */
    root.querySelectorAll('[data-mj-pr-scroll]').forEach(function (track) {
      var box = track.parentNode;
      var prev = box.querySelector('[data-mj-pr-prev]');
      var next = box.querySelector('[data-mj-pr-next]');
      var dots = track.hasAttribute('data-mj-pr-dotted') ? box.querySelector('[data-mj-pr-dots]') : null;
      var pageWidth = function () {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return track.clientWidth + gap;
      };
      var pages = function () { return Math.max(1, Math.round((track.scrollWidth + (parseFloat(getComputedStyle(track).columnGap) || 0)) / pageWidth())); };
      var go = function (dir) { track.scrollBy({ left: dir * pageWidth(), behavior: 'smooth' }); };
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      var update = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
        if (!dots) return;
        var n = pages();
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));
        }
        dots.hidden = n < 2;
        var idx = track.scrollLeft >= max ? n - 1 : Math.round(track.scrollLeft / pageWidth());
        for (var j = 0; j < n; j++) dots.children[j].classList.toggle('is-active', j === idx);
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    /* Lightbox */
    var lb = root.querySelector('[data-mj-pr-lb]');
    document.body.appendChild(lb);
    var q = function (s) { return lb.querySelector(s); };
    function closeLb() { lb.hidden = true; document.body.classList.remove('mj-pr-lb-open'); }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mj-pr-open]');
      if (!b) return;
      q('[data-mj-pr-lb-img]').src = b.dataset.src;
      q('[data-mj-pr-lb-img]').alt = (isEN ? 'Photo shared by ' : 'Foto van ') + b.dataset.name;
      q('[data-mj-pr-lb-title]').textContent = b.dataset.title ? '“' + b.dataset.title + '”' : '';
      q('[data-mj-pr-lb-body]').textContent = b.dataset.body || '';
      q('[data-mj-pr-lb-name]').textContent = b.dataset.name || '';
      q('[data-mj-pr-lb-stars]').innerHTML = new Array(+b.dataset.rating + 1).join(starSvg);
      lb.hidden = false;
      document.body.classList.add('mj-pr-lb-open');
      q('.mj-pr-lb__close').focus();
    });
    lb.addEventListener('click', function (e) { if (e.target.closest('[data-mj-pr-close]')) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
  }
  document.querySelectorAll('.mj-pr').forEach(init);
})();
